import { ComponentIdentityButton } from './component_identity_button';
import { ComponentIdentityButtonIcon } from './component_identity_button_icon';
import { ComponentIdentityImage } from './component_identity_image';
import { ComponentIdentityList } from './component_identity_list';
import { ComponentIdentityText } from './component_identity_text';
import { ComponentIdentityRockBottom } from './component_identity_rock_bottom';
import {
	GuiComponentButton,
	GuiComponentButtonIcon,
	GuiComponentImage,
	GuiComponentList,
	GuiComponentText,
} from '../api/v2/Models/GuiComponentApiModel';
import { Injectable } from '@angular/core';
import { SpaContext } from '../../Classes/spacontext';

export type ComponentUnion =
	| ComponentIdentityButton
	| ComponentIdentityButtonIcon
	| ComponentIdentityImage
	| ComponentIdentityList
	| ComponentIdentityText
	| ComponentIdentityRockBottom;

interface PassedData<T> {
	id: number;
	backendMessage: T;
}

@Injectable()
export class IdentityFactoryService {
	constructor(public readonly spaContext: SpaContext) {
		// Empty
	}

	public produce(type: 'Button', data: PassedData<unknown>): ComponentIdentityButton;
	public produce(type: 'Button.Icon', data: PassedData<unknown>): ComponentIdentityButtonIcon;
	public produce(type: 'Image', data: PassedData<unknown>): ComponentIdentityImage;
	public produce(type: 'List', data: PassedData<unknown>): ComponentIdentityList;
	public produce(type: 'Text', data: PassedData<unknown>): ComponentIdentityText;
	public produce(type: string, data: PassedData<unknown>): ComponentUnion;
	public produce(
		type: 'Button' | 'Button.Icon' | 'Image' | 'List' | 'Text' | string,
		passedData: PassedData<unknown>,
	): ComponentUnion {
		switch (type) {
			case 'Button': {
				const message = passedData.backendMessage as GuiComponentButton;

				let url = message.Url;
				if (message.OpenUrlWith === 'SameTab') {
					url = this.convertUrlToValidRouterPathService(url);
				}

				return new ComponentIdentityButton({
					url,
					id: passedData.id,
					hasBrandedNavbar: message.HasBrandedNavbar,
					openAnotherApp: message.OpenAnotherApp,
					openUrlWith: message.OpenUrlWith,
					requiresAuthentication: message.RequiresAuthentication,
					title: message.Title,
					subtitle: message.Subtitle,
				});
			}
			case 'Button.Icon': {
				const message = passedData.backendMessage as GuiComponentButtonIcon;

				let url = message.Url;
				if (message.OpenUrlWith === 'SameTab') {
					url = this.convertUrlToValidRouterPathService(url);
				}

				return new ComponentIdentityButtonIcon({
					url,
					id: passedData.id,
					hasBrandedNavbar: message.HasBrandedNavbar,
					openAnotherApp: message.OpenAnotherApp,
					openUrlWith: message.OpenUrlWith,
					requiresAuthentication: message.RequiresAuthentication,
					title: message.Title,
					subtitle: message.Subtitle,
					imageUrl: message.IconSvgUrl,
				});
			}
			case 'Image': {
				const message = passedData.backendMessage as GuiComponentImage;

				return new ComponentIdentityImage({
					id: passedData.id,
					altText: message.AltText,
					imageUrl: message.ImageUrl,
				});
			}
			case 'List': {
				const message = passedData.backendMessage as GuiComponentList;

				return new ComponentIdentityList({
					id: passedData.id,
					title: message.Title,
					items: message.Items,
				});
			}
			case 'Text': {
				const message = passedData.backendMessage as GuiComponentText;

				return new ComponentIdentityText({
					id: passedData.id,
					text: message.Text,
				});
			}
			default: {
				const subdivideTypes = type.split('.');
				if (subdivideTypes.length === 1) {
					return new ComponentIdentityRockBottom({
						id: passedData.id,
					});
				}

				subdivideTypes.pop();
				const glueTogether = subdivideTypes.join('.');

				return this.produce(glueTogether, passedData);
			}
		}
	}


	private convertUrlToValidRouterPathService(str: string): string {
		// https://media.giphy.com/media/3FQ87l4tXAZWGvV3yY/giphy.gif

		// This is how links worked before, it's not a downgrade but it's not good
		return str;
	}
}
